import React from "react";

import ReactSlot from "@/react-components/ReactSlot";

class FenrirSection extends React.Component {
  componentDidMount() {
    this.removeClass();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps?.router?.location?.pathname !==
      this.props?.router?.location?.pathname
    ) {
      this.removeClass();
    }
  }

  componentWillUnmount() {
    this.addClass();
  }

  removeClass = () => {
    const main = document.getElementById("content-main");
    if (main.classList.contains("content-main-padding")) {
      main.classList.remove("content-main-padding");
    }
  };

  addClass = () => {
    const main = document.getElementById("content-main");
    if (!main.classList.contains("content-main-padding")) {
      main.classList.add("content-main-padding");
    }
  };

  render() {
    return (
      <ReactSlot key={this.props?.router?.location?.key} {...this.props} />
    );
  }
}

export default FenrirSection;
